import { render, staticRenderFns } from "./CreateOneGroup.vue?vue&type=template&id=5a20acf4&scoped=true"
import script from "./CreateOneGroup.vue?vue&type=script&lang=js"
export * from "./CreateOneGroup.vue?vue&type=script&lang=js"
import style0 from "./CreateOneGroup.vue?vue&type=style&index=0&id=5a20acf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a20acf4",
  null
  
)

export default component.exports